import AjaxPromises from '../utils/AjaxPromises';

import { endPoints as EndPoints } from '../constants/PosCartConstants';

export default {

    loadUserCart:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_USER_CART, formData);
    },
    loadCartPayment:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_CART_PAYMENT, formData);
    },
    loadCartDetails:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_CART_DETAILS, formData);
    },

    loadPreOrders:(formData) => {
        return AjaxPromises.POST(EndPoints.LOAD_PRE_ORDERS, formData);
    },

    loadUserAllotment:(formData) => {
        return AjaxPromises.POST(EndPoints.ALLOTMENT, formData);
    },

    clearUserCart:(formData) => {
        return AjaxPromises.POST(EndPoints.CLEAR_CART, formData);
    },

    addItemToCart:(formData) => {
        return AjaxPromises.POST(EndPoints.ADD_TO_CART, formData);
    },

    addBulkItemToCart:(formData) => {
        return AjaxPromises.POST(EndPoints.ADD_BULK_TO_CART, formData);
    },

    removeItemFromCart:(formData) => {
        return AjaxPromises.POST(EndPoints.REMOVE_FROM_CART, formData);
    },

    editItem:(formData) => {
        return AjaxPromises.POST(EndPoints.EDIT_ITEM, formData);
    },

    removeAppliedDiscount:(formData) => {
        return AjaxPromises.POST(EndPoints.REMOVE_APPLIED_DISCOUNT, formData);
    },

    removeAppliedFeeDonation:(formData) => {
        return AjaxPromises.POST(EndPoints.REMOVE_APPLIED_FEE_DONATION, formData);
    },

    applyDiscountByCode:(formData) => {
        return AjaxPromises.POST(EndPoints.APPLY_DISOCUNT_BY_CODE, formData);
    },

    netaAutoPrice:(formData) => {
        return AjaxPromises.POST(EndPoints.NETA_AUTO_PRICE, formData);
    },

    netaAutoDiscount:(formData) => {
        return AjaxPromises.POST(EndPoints.NETA_AUTO_DISCOUNT, formData);
    },

    loadAppliedDiscounts:(formData) => {
        return AjaxPromises.POST(EndPoints.APPLIED_DISCOUNTS, formData);
    },

}



// WEBPACK FOOTER //
// ./ui_src/app/api/PosCartApi.jsx